module.exports = __webpack_public_path__ + "img/7-7.a21f9853.png";